import {
	database,
} from 'utils/database';
import {
	isDone,
} from 'utils/transport';
import {
	Assignment,
	GateCounterModel,
} from 'models';

const ONE_MINUTE = 60000;

const addToGateCounter = async (gateInfo: GateCounterModel) => await database.openGateCounter.add(gateInfo);
const putToGateCounter = async (gateInfo: GateCounterModel) => await database.openGateCounter.put(gateInfo);
const getGateCounter = async (container: string, gln: string, date: string) =>
	await database.openGateCounter.where('[gln+container+date]').equals([gln, container, date]).toArray();

const updateOpenGateCounter = async (container: string, gln: string, date: string) => {
	const dataCurrent = await getGateCounter(container, gln, date);
	// UPDATE COUNTER for container+gln+date
	if (dataCurrent && dataCurrent.length > 0) {

		if (openGateCounterTimeCapHasPassed(dataCurrent[0])) {
			const data = {
				...dataCurrent[0],
				counter: dataCurrent[0].counter + 1,
				timestamp: Date.now(),
			};
			await putToGateCounter(data);
		}
		// else: TIMECAP NOT PASSED: don't bump counter
	}
	// CREATE COUNTER for container+gln+date
	else {
		const data: GateCounterModel = {
			container,
			gln,
			date,
			counter: 1,
			timestamp: Date.now(),
		};
		await addToGateCounter(data);
	}
}

const handleOpenGateCounter = async (data: Assignment, container: string, gln: string, date: string): Promise<{
    shouldOpenGate: boolean,
    shouldShowConfirm: boolean,
}> => {
	const dataCurrent = await getGateCounter(container, gln, date);

	if (dataCurrent && dataCurrent.length > 0) {
		if (!isDone(data) && openGateCounterTimeCapHasPassed(dataCurrent[0])) {
			return {
				shouldOpenGate: false,
				shouldShowConfirm: true,
			}
		}
	}
	return {
		shouldOpenGate: true,
		shouldShowConfirm: false,
	}
}

const openGateCounterTimeCapHasPassed = (data: GateCounterModel) => {
	const timeNow = new Date();
	const newInsertCap = new Date(data.timestamp + (ONE_MINUTE * 5));
	return timeNow >= newInsertCap ? true : false;
}

export {
	updateOpenGateCounter,
	handleOpenGateCounter,
}